import { atom } from 'jotai'

/** ドラッグ中のポインタがピン止め行のドッキング表示上にあるか。ボードの auto-scroll 抑止に使う。 */
export const draggingOnPinnedRowAtom = atom(false)

draggingOnPinnedRowAtom.debugLabel = 'draggingOnPinnedRowAtom'
